import {
  ProductDetailsAlsoSearch,
  ProductDetailsAlsoSearchSkeleton,
} from '@components/product/ProductDetailsAlsoSearch';

import { useProductDetailsAlsoSearchQuery } from './gql/graphql.v5.generated';

interface Props {
  className?: string,
  productId: number,
}

export const ProductDetailsAlsoSearchContainer: React.FC<Props> = ({
  className,
  productId,
}) => {
  const { data, loading } = useProductDetailsAlsoSearchQuery({
    variables: {
      id: productId,
    },
    context: {
      v5: true,
    },
  });

  if (loading) {
    return (
      <ProductDetailsAlsoSearchSkeleton className={className} />
    );
  }

  if (data?.product) {
    return (
      <ProductDetailsAlsoSearch
        className={className}
        links={data.product.alsoSearchLinks}
      />
    );
  }

  return null;
};
